import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/(lang)/contact-us/loading.jsx");
